module.exports = __webpack_public_path__ + "img/sceneca_1.97638e91.png";